import App from '@/vue/App.vue'
import { createApp } from 'vue'
import { store } from './stores/store.js'

// App main
const main = async () => {

    // Async load the vue module
    const [ Vue, Lazysizes ] = await Promise.all([
        import(/* webpackChunkName: "vue" */ 'vue'),
        import(/* webpackChunkName: "lazysizes" */ 'lazysizes'),
    ]).then(arr => arr.map(({ default: defaults }) => defaults));

    const app = createApp(App)

    // Mount Vuex
    app.use(store)

    // Mount the app 
    const root = app.mount('#page-container')
    
    // Wait for HTMX to be available
    const initSprig = () => {
        if (typeof window.htmx !== 'undefined') {
            const sprigAreas = document.querySelectorAll('[data-sprig-area]');
            sprigAreas.forEach(area => {
                window.htmx.process(area);
            });
        } else {
            console.warn('HTMX not loaded yet, retrying...');
            setTimeout(initSprig, 100); // Retry after 100ms
        }
    };
    
    // Use requestAnimationFrame to ensure DOM is ready
    requestAnimationFrame(() => {
        requestAnimationFrame(initSprig);
    });

    return root
}

// Execute async function
main().then( (root) => {});

// Accept HMR as per: https://webpack.js.org/api/hot-module-replacement#accept
if (module.hot) {
    module.hot.accept();
}